import { useCallback } from "react";
import { PublicKey, SystemProgram, Transaction, LAMPORTS_PER_SOL } from "@solana/web3.js";
import { api } from "@/lib/api";

export const phantomProvider = () => window.phantom?.solana || (window.solana?.isPhantom ? window.solana : null);
const b64 = (a) => btoa(String.fromCharCode(...a));

export const requireProvider = () => {
  const p = phantomProvider();
  if (!p) {
    window.open("https://phantom.app/", "_blank");
    throw new Error("Phantom wallet not detected. Install the extension.");
  }
  return p;
};

export async function phantomSignIn() {
  const p = requireProvider();
  const r = await p.connect();
  const wallet = r.publicKey.toString();
  const { data: c } = await api.post("/auth/challenge", { wallet });
  const signed = await p.signMessage(new TextEncoder().encode(c.message), "utf8");
  const { data } = await api.post("/auth/complete", { wallet, nonce: c.nonce, signature_b64: b64(signed.signature) });
  return data;
}

export async function sendSol(toAddress, lamports) {
  const p = requireProvider();
  if (!p.publicKey) await p.connect();
  const { data } = await api.get("/wallet/blockhash");
  const from = p.publicKey;
  const tx = new Transaction({ feePayer: from, recentBlockhash: data.blockhash }).add(
    SystemProgram.transfer({ fromPubkey: from, toPubkey: new PublicKey(toAddress), lamports: Math.round(lamports) }),
  );
  const { signature } = await p.signAndSendTransaction(tx);
  return signature;
}

export function usePhantom() {
  const fund = useCallback((toAddress, sol) => sendSol(toAddress, sol * LAMPORTS_PER_SOL), []);
  return { fund };
}
